export default "__VITE_ASSET__Jds9Fx9z__"